module.exports = __webpack_public_path__ + "static/media/DataOpsAnalyticsIcon.d4bc6870.svg";